import { Box, Button, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

import AppManagerRoleBanner from 'routes/application/Configure/components/RoleBanner'

import { MODAL_NAMES } from '..'
import type { extension } from '..'
import { useCanViewReadOnly } from '../../useCanConfigureApplications'

const useStyles = makeStyles((theme) => ({
  topLineWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'center',
    },
  },
  header: {
    fontSize: theme.typography.pxToRem(48),
    flexGrow: 1,
  },
  secondaryHeader: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
  },
  CTA: {
    alignSelf: 'flex-start',
    marginTop: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      alignSelf: 'flex-end',
    },
  },
}))

export const HEADER_TEXT = {
  header: 'Cut-Off Extensions',
  secondaryHeader: 'Students with application extensions',
  info: 'Individual application cut-off extensions will appear below. You must enter the student’s email address as it appears on the application.',
  cta: 'Add New Extension',
  readOnly: {
    strong: 'Read-Only View:',
    body: "You currently don't have the permissions to update this page. If you would like access, please contact the Account Administrator at your institution and request the Application Manager role.",
  },
}

type headerProps = {
  onOpen: ({ name, extension }: { name: string; extension?: extension }) => void
}

const Header = ({ onOpen }: headerProps) => {
  const classes = useStyles()
  const readOnlyView = useCanViewReadOnly()

  return (
    <Box py={5}>
      <AppManagerRoleBanner />
      <Box className={classes.topLineWrapper}>
        <Typography
          variant="h3"
          component="h1"
          className={classes.header}
        >
          {HEADER_TEXT.header}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className={classes.CTA}
          disabled={readOnlyView}
          onClick={() => onOpen({ name: MODAL_NAMES.add })}
        >
          {HEADER_TEXT.cta}
        </Button>
      </Box>
      <Box mt={4.3}>
        <Typography
          variant="h6"
          component="h2"
          className={classes.secondaryHeader}
        >
          {HEADER_TEXT.secondaryHeader}
        </Typography>
      </Box>
      <Box mt={0.5}>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          {HEADER_TEXT.info}
        </Typography>
      </Box>
    </Box>
  )
}

export default Header
